import Image from "next/image";
import Link from "next/link";
import { useTranslation } from "react-i18next";

const ContactCard = () => {
  const { t } = useTranslation('faq')

  return (
    <div className='flex flex-col items-center w-full'>
      <p className='font-pretendard-regular text-[14px] font-normal text-text-main-lv4 mb-[16px] mt-[55px] sm:hidden'>{t('no_results_title')}</p>
      <Link href="/contact" className='flex items-center gap-[10px] w-full px-[20px] py-[16px] bg-background-light dark:bg-background-elevated rounded-[12px] shadow-[0_0_2px_0_rgba(0,0,0,0.03),0_0_12px_0_rgba(0,0,0,0.07)] dark:shadow-[0_0_2px_0_rgba(0,0,0,0.68),0_0_14.8px_0_rgba(0,0,0,0.86)]'>
        <div className='p-[10px] bg-surface-lv2 rounded-full'>
          <Image src="/images/LoveLetter.png" alt="" width={32} height={32} />
        </div>
        <div className='flex flex-col gap-[4px]'>
          <p className='text-[14px] font-semibold text-[#444444] leading-[17px]'>{t('contact_direct')}</p>
          <p className='text-[12px] font-medium text-text-main-lv4 leading-[14px]'>{t('no_results_description')}</p>
        </div>
      </Link>
    </div>)
}

export default ContactCard;